<div class="row">  
  <span class="col-md-12 text-right boldlbl">Page 7 of 10</span>  
</div>
<div *ngIf="loaderService.isLoading | async" id="pause" class="d-flex align-items-center justify-content-center">
    <div id="spinner"></div>
</div>
<div class="row p-4">
    <div class="col-md-12 text-center">
        <h3>{{eAppRegConstant.PageHeader}}<br /></h3>
        <h4>Confirmation</h4>
    </div>
</div>
<div class="row">
    <div class="col-md-12">
        <h4 class="boldlbl">APPLICANT BUSINESS INFORMATION</h4>
    </div>
</div>
<form *ngIf="!(loaderService.isLoading | async)" [formGroup]="eappreg_confirm" (ngSubmit)="eappreg_confirm_action()">
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <p class="undln boldlbl">Account Information</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">Business Description:</label>
                </div>
                <div class="col-md-6">
                    <label>{{trcAppForm.bus_Desc}}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">Legal Name:</label>
                </div>
                <div class="col-md-6">
                    <label>{{trcAppForm.busid_Legal_Nm}}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">DBA Name:</label>
                </div>
                <div class="col-md-6">
                    <label>{{trcAppForm.busid_Dba_Nm}}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">Business Type:</label>
                </div>
                <div class="col-md-6">
                    <label>{{busType | uppercase}}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">LA Start Date:</label>
                </div>
                <div class="col-md-6">
                    <label>{{trcAppForm.busact_Start_Dt}}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">Seller's Permit Number:</label>
                </div>
                <div class="col-md-6">
                    <label>{{trcAppForm.busact_Seller_Permit}}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">Primary Activity Code:</label>
                </div>
                <div class="col-md-6">
                    <label>{{trcAppForm.busact_Irs_Activity_Cd}}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">Primary SIC Code:</label>
                </div>
                <div class="col-md-6">
                    <label>{{trcAppForm.busact_Irs_Activity_Cd3}}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">Secondary Activity Code:</label>
                </div>
                <div class="col-md-6">
                    <label>{{trcAppForm.busact_Irs_Activity_Cd2}}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">Secondary SIC Code:</label>
                </div>
                <div class="col-md-6">
                    <label>{{trcAppForm.busact_Irs_Activity_Cd4}}</label>
                </div>
            </div>
            <p>&nbsp;</p>
            <div class="row">
                <div class="col-md-12">
                    <p class="undln boldlbl">Business Address</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">Address</label>
                </div>
                <div class="d-flex flex-row  col-md-9">
                    <div class="my-2">
                        <label class="undln">Street Number</label><br />
                        <label>{{trcAppForm.ba1_Str_Nbr}}</label>
                    </div>
                    <div class="m-2">
                        <label class="undln">Street Number Fraction</label><br />
                        <label>{{trcAppForm.ba1_Str_Nbr_Frac}}</label>
                    </div>
                    <div class="m-2">
                        <label class="undln">Dir Prefix</label><br />
                        <label>{{trcAppForm.ba1_Str_Dir_Prefix}}</label>
                    </div>
                    <div class="m-2">
                        <label class="undln">Street Name</label><br />
                        <label>{{trcAppForm.ba1_Str_Nm}}</label>
                    </div>
                    <div class="m-2">
                        <label class="undln">Street Type</label><br />
                        <label>{{sessionStorage.TRCqBAStreetType}}</label>
                    </div>
                    <div class="m-2">
                        <label class="undln">Dir Suffix</label><br />
                        <label>{{trcAppForm.ba1_Str_Dir_Suffix}}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="d-flex flex-row col-md-9 offset-md-3">
                    <div class="my-2">
                        <label class="undln">Unit Type</label><br />
                        <label>{{bAUnitType}}</label>
                    </div>
                    <div class="m-2">
                        <label class="undln">Unit Number</label><br />
                        <label>{{trcAppForm.ba2_Unit_Nbr}}</label>
                    </div>
                    <div class="m-2">
                        <label class="undln">Care Of</label><br />
                        <label>{{trcAppForm.ba2_CareOf}}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="d-flex flex-row  col-md-9 offset-md-3">
                    <div class="my-2">
                        <label class="undln">City</label><br />
                        <label>{{trcAppForm.ba3_City}}</label>
                    </div>
                    <div class="m-2">
                        <label class="undln">State</label><br />
                        <label>{{trcAppForm.ba3_State}}</label>
                    </div>
                    <div class="m-2">
                        <label class="undln">ZIP Code</label><br />
                        <label>{{trcAppForm.ba3_ZipCd}}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">Location Type:</label>
                </div>
                <div class="col-md-9">
                    <ng-container *ngIf=" trcAppForm.ba0_Commerical == 'Y'; else res">
                        COMMERCIAL
                    </ng-container>
                    <ng-template #res>
                        RESIDENCE
                    </ng-template>
                </div>
            </div>
            <p>&nbsp;</p>
            <div class="row">
                <div class="col-md-12">
                    <p class="undln boldlbl">Mailing Address</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">Address</label>
                </div>
                <div class="d-flex flex-row  col-md-9">
                    <div class="my-2">
                        <label class="undln">Street Number</label><br />
                        <label>{{trcAppForm.ma1_Str_Nbr}}</label>
                    </div>
                    <div class="m-2">
                        <label class="undln">Street Number Fraction</label><br />
                        <label>{{trcAppForm.ma1_Str_Nbr_Frac}}</label>
                    </div>
                    <div class="m-2">
                        <label class="undln">Dir Prefix</label><br />
                        <label>{{trcAppForm.ma1_Str_Dir_Prefix}}</label>
                    </div>
                    <div class="m-2">
                        <label class="undln">Street Name</label><br />
                        <label>{{trcAppForm.ma1_Str_Nm}}</label>
                    </div>
                    <div class="m-2">
                        <label class="undln">Street Type</label><br />
                        <label>{{sessionStorage.TRCqMAStreetType}}</label>
                    </div>
                    <div class="m-2">
                        <label class="undln">Dir Suffix</label><br />
                        <label>{{trcAppForm.ma1_Str_Dir_Suffix}}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="d-flex flex-row  col-md-9 offset-md-3">
                    <div class="my-2">
                        <label class="undln">Unit Type</label><br />
                        <label>{{mAUnitType}}</label>
                    </div>
                    <div class="m-2">
                        <label class="undln">Unit Number</label><br />
                        <label>{{trcAppForm.ma2_Unit_Nbr}}</label>
                    </div>
                    <div class="m-2">
                        <label class="undln">Care Of</label><br />
                        <label>{{trcAppForm.ma2_CareOf}}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="d-flex flex-row col-md-9 offset-md-3">
                    <div class="my-2">
                        <label class="undln">City</label><br />
                        <label>{{trcAppForm.ma3_City}}</label>
                    </div>
                    <div class="m-2">
                        <label class="undln">State</label><br />
                        <label>{{trcAppForm.ma3_State}}</label>
                    </div>
                    <div class="m-2">
                        <label class="undln">ZIP Code</label><br />
                        <label>{{trcAppForm.ma3_ZipCd}}</label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">Location Type:</label>
                </div>
                <div class="col-md-9">
                    <ng-container *ngIf=" trcAppForm.ma0_Commerical == 'Y'; else res">
                        COMMERCIAL
                    </ng-container>
                    <ng-template #res>
                        RESIDENCE
                    </ng-template>
                </div>
            </div>
            <p>&nbsp;</p>
            <div class="row">
                <div class="col-md-12">
                    <p class="undln boldlbl">Business Contact Information</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">First Name:</label>
                </div>
                <div class="col-md-9">
                    <label>{{trcAppForm.buson_Name_First}}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">Last Name:</label>
                </div>
                <div class="col-md-9">
                    <label>{{trcAppForm.buson_Name_Last}}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">Title:</label>
                </div>
                <div class="col-md-9">
                    <label>{{trcAppForm.buson_Title}}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">Phone:</label>
                </div>
                <div class="col-md-9">
                    <span *ngIf="trcAppForm.buson_Phone_Nbr !== '' ">
                        {{trcAppForm.buson_Phone_Nbr}}
                    </span>
                    &nbsp;&nbsp;&nbsp;<b>Ext:</b>
                    {{trcAppForm.buson_Phone_Ext}}
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">Email:</label>
                </div>
                <div class="col-md-9">
                    <label>{{trcAppForm.buson_Email}}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">Business Web Address (URL):</label>
                </div>
                <div class="col-md-9">
                    <label>{{trcAppForm.buson_Web_Address}}</label>
                </div>
            </div>
            <p>&nbsp;</p>
            <div class="row">
                <div class="col-md-12">
                    <p class="undln boldlbl">Filer Information</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <p>I declare, under penalty or perjury under the laws of the State of California that to the best of my knowledge the information provided in this application is true, correct and complete.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">First Name:</label>
                </div>
                <div class="col-md-9">
                    <label>{{trcAppForm.filer_Name_First}}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">Last Name:</label>
                </div>
                <div class="col-md-9">
                    <label>{{trcAppForm.filer_Name_Last}}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">Title:</label>
                </div>
                <div class="col-md-9">
                    <label>{{trcAppForm.filer_Title}}</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">Phone:</label>
                </div>
                <div class="col-md-9">
                 <span *ngIf="trcAppForm.filer_Phone_Nbr !== '' ">
                        {{trcAppForm.filer_Phone_Nbr}}
                    </span>
                    &nbsp;&nbsp;&nbsp;<b>Ext:</b>
                    {{trcAppForm.filer_Phone_Ext}}
                    <!-- <label>{{trcAppForm.filer_Phone_Nbr}}&nbsp;&nbsp;&nbsp;<b>Ext:</b>{{trcAppForm.filer_Phone_Ext}}</label> -->
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label class="boldlbl">Email:</label>
                </div>
                <div class="col-md-9">
                    <label>{{trcAppForm.filer_Email}}</label>
                </div>
            </div>
            <br />
        </div>
    </div>
    <br/>
    <h4 class="boldlbl">QUESTIONNAIRE</h4>
        <div class="card">
            <div class="card-body">
                <ng-container *ngFor="let group of trcQGroups;let i = index">
                    <container-element [ngSwitch]="group.metaName">
                        <ng-container *ngSwitchCase="'DUPENTRYGRP'">
                            <p class="boldlbl">{{group.seqNbr}}. {{group.questionGroup}}</p>
                            {{setTRCCurrGrpMetaName(group.metaName)}}
                            <table class="table table-borderless">
                                <jhi-dsp-questions-answers [qQuestions]="qQuestions" [parentForm]="eappreg_confirm"
                                    [DispOnlyInd]="DispOnlyInd" [DispSeqInd]="DispSeqIndY" style="display:contents">
                                </jhi-dsp-questions-answers>
                            </table>
                        </ng-container>
                        <ng-container *ngSwitchCase="'BUSINESSGRP'">
                            <p class="boldlbl">{{group.seqNbr}}. {{group.questionGroup}}</p>
                            {{setTRCCurrGrpMetaName(group.metaName)}}
                            <table class="table table-borderless">
                                <jhi-dsp-questions-answers [qQuestions]="qQuestions1" [parentForm]="eappreg_confirm"
                                [DispOnlyInd]="DispOnlyInd" [DispSeqInd]="DispSeqIndN" style="display:contents">
                                </jhi-dsp-questions-answers>
                                <jhi-dsp-questions-answers [DispSeqInd]="DispSeqIndN" [qQuestions]="level2Questionnaire" [parentForm]="eappreg_confirm"
                                [DispOnlyInd]="DispOnlyInd" style="display:contents">
                                </jhi-dsp-questions-answers>
                                <jhi-dsp-questions-answers [DispSeqInd]="DispSeqIndN" [qQuestions]="level3Questionnaire" [parentForm]="eappreg_confirm"
                                [DispOnlyInd]="DispOnlyInd" style="display:contents">
                                </jhi-dsp-questions-answers>
                            </table>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <ng-container *ngIf="permitQuestions[i-2]?.qPermitQues.length > 0">
                                <p class="boldlbl">{{group.seqNbr}}. {{group.questionGroup}}</p>
                                <table class="table table-borderless">
                                    <!--- Loops thru questions in group --->
                                    {{setTRCCurrGrpMetaName(group.metaName)}}
                                    <jhi-dsp-questions-answers [qQuestions]="permitQuestions[i-2]?.qPermitQues"
                                        [parentForm]="eappreg_confirm" [DispOnlyInd]="DispOnlyInd" [DispSeqInd]="DispSeqIndN"
                                        style="display:contents">
                                    </jhi-dsp-questions-answers>
                                </table>
                            </ng-container>
                        </ng-container>
                    </container-element>
                </ng-container>
            </div>
        </div>
    <div>
        <br>
    </div>
    <div class="row">
        <div class="col-md-12 text-center">
            <input type="button" class="btn btn-primary my-2" value="Back" (click)="back()"/>
            <input type="button" class="btn btn-primary my-2" value="Print" (click)="print_page()"/>
            <button class="btn btn-primary my-2" type="submit">Submit</button>
        </div>
    </div>
    <div>
        <br>
    </div>
</form>